<template>
  <div class="MissionsPage">
    <!-- tab栏 -->
    <div class="MissionsPage-tab">
      <div
        class="MissionsPage-tab-daily longTouch"
        :class="{ Selected: tabStyle === 'daily' }"
        @click="handleSelect('daily')"
      >
        {{localesPackage?.['katharsis_daily']?.[localesEnv]}}
        <div class="unClaimed" v-if="red_daily_show">
          <img
            :src="require('@/assets/images/YuliApp/weeklyTask/gantanhao.svg')"
          />
        </div>
      </div>
      <div
        class="MissionsPage-tab-weekly longTouch"
        :class="{Selected: tabStyle === 'weekly' }"
        @click="handleSelect('weekly')"
      >
        {{localesPackage?.['katharsis_weekly']?.[localesEnv]}}
        <div class="unClaimed" v-if="red_weekly_show">
          <img
            :src="require('@/assets/images/YuliApp/weeklyTask/gantanhao.svg')"
          />
        </div>
      </div>
    </div>

    <!-- 内容 -->
    <div class="MissionsPage-content" v-if="dataList.length > 0">
      <RowLine
        v-for="item in dataList"
        :key="item.id"
        :task_id="item.id"
        :desc="item.name"
        :total_level="item.count"
        :cur_progress="item.progress"
        :kep_num="item.kep"
        :task_state="item.state"
        :period_id="period_id"
        :mission_item="item"
        :isClaiming="claimingState"
        @handleMissionsClaim="handleMissionsClaim"
        @claiming="handleClaiming"
      ></RowLine>
    </div>
    <!-- 内容缺省 -->
    <div class="MissionsPage-mask" v-else>
      <img :src="require('@/assets/images/YuliApp/weeklyTask/robot_wait.svg')">
      <div class="MissionsPage-mask-text">{{ localesPackage?.['og_no_reward_tips']?.[localesEnv] }}</div>
      <div class="MissionsPage-mask-text2">{{ localesPackage?.['og_no_reward_tips2']?.[localesEnv] }}</div>
    </div>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref } from "vue";
import RowLine from "./components/RowLine";
import { TASK_STATE_TYPE } from "@/constants/enums";
import audioManager from "@/utils/audioManager";
import { mapState } from "vuex";
export default {
  components: {
    RowLine,
  },
  computed: {
    ...mapState({
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  props: {
    missionData: {
      type: Array,
      default: () => [],
    },
    period_id: {
      type: String,
      default: "",
    },
    isClaiming: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    missionData: {
      handler(value) {
        if (!value || !value?.length) {
          return;
        }

        this.init(value);
      },
      immediate: true,
      deep: true,
    },
    isClaiming: {
      handler(value) {
        this.claimingState = value;
      },
      immediate: true,
      deep: true
    },
    languageEnv: {
      async handler(value) {
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if(value){
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    }
  },
  setup(props, { emit }) {
    const tabStyle = ref("daily");
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const dailyData = ref([]);
    const weeklyData = ref([]);
    const dataList = ref([]);
    const red_daily_show = ref(false); //控制红点展示
    const red_weekly_show = ref(false);
    const claimingState = ref(false);

    onMounted(() => {});

    const init = (value) => {
      //过滤 每日任务和周任务
      handleFilterData(value);

      //排序
      dailyData.value = sortData(dailyData.value);
      weeklyData.value = sortData(weeklyData.value);

      dataList.value =
        tabStyle.value === "daily" || !tabStyle.value
          ? dailyData.value
          : weeklyData.value;

      //判断红点
      red_daily_show.value = handleTabRedCircle(dailyData.value, "daily");
      red_weekly_show.value = handleTabRedCircle(weeklyData.value, "weekly");
    };

    const handleFilterData = (data) => {
      const daily_data = [];
      const weekly_data = [];
      data.forEach((item, index) => {
        if (item.mission_type === 1) {
          daily_data.push(item);
        } else {
          weekly_data.push(item);
        }
      });
      dailyData.value = daily_data;
      weeklyData.value = weekly_data;
    };

    /**
     * 处理tab切换
     */
    const handleSelect = async (type) => {
      type !== tabStyle.value && audioManager.playEffect("secondmenu");
      tabStyle.value = type;

      if (type === "daily") {
        dataList.value = dailyData.value;
      } else {
        dataList.value = weeklyData.value;
      }
    };

    /**
     * 处理claim按钮领取奖励
     */
    const handleMissionsClaim = (task_id, task_kep, missionItem) => {
      emit("handleMissionsClaim", task_id, task_kep, missionItem);
    };

    /**
     * 处理点击claim限制
     */
    const handleClaiming = (state) => {
      emit("claiming", state);
    };

    /**
     * 判断 daily、weekly Tab红点展示
     */
    const handleTabRedCircle = (data, type) => {
      let flag = false;
      data.forEach((_item, index) => {
        const item = JSON.parse(JSON.stringify(_item));
        if (item.state === TASK_STATE_TYPE.CLAIM) {
          flag = true;
        }
      });
      return flag;
    };

    /**
     * 重新排序 未被领取的
     */
    const sortData = (data) => {
      const onProgress = [];
      const not_claimed = [];
      const claimed = [];

      //过滤已被领取的、未被领取满级的、不到30级的
      data.forEach((item, index) => {
        switch (item.state) {
          case TASK_STATE_TYPE.CLAIM:
            not_claimed.push(item);
            break;
          case TASK_STATE_TYPE.IN_PROGRESS:
            onProgress.push(item);
            break;
          case TASK_STATE_TYPE.CLAIMED:
            claimed.push(item);
            break;
        }
      });

      return not_claimed.concat(onProgress).concat(claimed);
    };

    /**
     * claim领取经验之后刷新页面
     */
    const refresh = () => {};
    return {
      handleSelect,
      handleMissionsClaim,
      init,
      tabStyle,
      dataList,
      dailyData,
      weeklyData,
      red_daily_show,
      red_weekly_show,
      handleClaiming,
      claimingState,
      localesPackage,
      localesEnv,
    };
  },
};
</script>

<style lang="less" scoped>
//阻止长按操作
.longTouch {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}

.MissionsPage {
  height: 100%;
  background: linear-gradient(180deg, #9289D3 0%, #8C8DD4 33%, #7A81D1 44%, #7C87D0 66%, #7084CD 100%);
  &-tab {
    padding-top: 6px;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    &-daily,
    &-weekly {
      position: relative;
      width: 117px;
      height: 32px;
      font-size: 16px;
      color: #fff;
      font-size: 14px;
      font-weight: 600;
      font-family: "PingFang SC";
      text-align: center;
      line-height: 32px;
      position: relative;
    }
    .Selected {
      // background: url("~@/assets/images/YuliApp/weeklyTask/button_daily@2x.png")
      //   no-repeat top left;
      // background-size: 100% 100%;
      font-size: 22px;
    }
    .Selected::before{
      content: '';
      position: absolute;
      width: 28px;
      height: 2px;
      border-radius: 15px;
      background: #ffffffff;
      bottom: -5px;
      left: 50%;
      transform: translateX(-50%);
    }
    //未领取
    .unClaimed {
      position: absolute;
      top: -1px;
      right: 11px;
      width: 16px;
      height: 16px;
      background: rgba(222, 75, 75, 1);
      border-radius: 50%;
      img {
        position: absolute;
        left: 4.32px;
        bottom: 5.2px;
        width: 14px;
        height: 16px;
      }
    }
  }
  &-content {
    display: flex;
    flex-direction: column;
    align-items: center;

    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
  &-mask{
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: fixed;
    bottom: 0;
    z-index: 20;
    // background: rgba(0, 0,0, 0.8);
    background: linear-gradient(180deg, #9289D3 0%, #8C8DD4 33%, #7A81D1 44%, #7C87D0 66%, #7084CD 100%);
    img{
      width: 100px;
      height: 100px;
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      top: 110px;
    }
    &-text{
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      top: 230px;
    }
    &-text2{
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      font-size: 13px;
      font-weight: 400;
      color: #fff;
      width: 100%;
      text-align: center;
      top: 290px;
    }
  }
  .RowLine:last-of-type {
    margin-bottom: 110px;
  }
  // .scroll {
  //   padding-bottom: 20px;
  //   height: 100%;
  //   overflow-y: scroll;
  //   -webkit-overflow-scrolling: touch;
  // }
  //隐藏滚动条
  .MissionsPage-content::-webkit-scrollbar {
    display: none;
  }
  .MissionsPage-content {
    scrollbar-width: none;
    -ms-overflow-style: none;
    overflow-y: scroll;
    overflow-x: hidden;
  }
}
</style>
